import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '@components/Input';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';

const Instructions = ({ isView }) => {
    const { t } = useTranslation();
    const { control } = useFormContext();

    return (
        <div>
            <Typography variant="subtitle1" sx={{ color: 'var(--text-primary)' }}>
                {t('Agents.customInstructions')}
            </Typography>
            <Typography
                variant="caption"
                sx={{ color: 'var(--text-secondary)', display: 'block', marginTop: '4px', marginBottom: '16px' }}
            >
                {t('Agents.customInstructionsDescription')}
            </Typography>
            <Controller
                control={control}
                name="customInstructions"
                render={({ field, fieldState: { error }, ref }) => (
                    <Input
                        ref={ref}
                        inputProps={{ ...field, onChange: e => field.onChange(e.target.value) }}
                        label={t('common.customInstructionsOpt')}
                        fullWidth
                        multiline
                        minRows={3}
                        maxLength={1000}
                        error={!!error}
                        helperText={error ? t(error.message, { count: 1000 }) : null}
                        disabled={isView}
                    />
                )}
            />
        </div>
    );
};

export default Instructions;
